import React, {useEffect, useRef, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import {CircularProgress, FormControl,} from "@material-ui/core";
import PhoneService from "../../services/PhoneService";
import useAdminUserSession from "../../../../hooks/useAdminUserSession";

const PhoneTextField = ({
                            clearPhone,
                            afterOnBlur,
                            ext,
                            otherPhones,
                            dataSet,
                            ...props
                        }) => {
    const [loadingPhoneValidation, setLoadingPhoneValidation] = useState(false);
    const [phoneValidated, setPhoneValidated] = useState(false);
    const [phoneErrorMessage, setPhoneErrorMessage] = useState('');
    const [addPrefix, setAddPrefix] = useState(true);
    const inputRef = useRef(null);
    const {session} = useAdminUserSession();

    useEffect(() => {
        const value = props.value?.trim();
        if (!value) return;

       if (value.startsWith('+') && !value.startsWith('+1')) {
            setAddPrefix(false);
        }
    }, []);

    const handlePhonePrefixChange = () => {
        setAddPrefix((prev) => {
            const next = !prev;
            let newValue = props.value || '';

            newValue = newValue.replace(/^\+1\s*/, '');

            if (next) newValue = `+1 ${newValue}`;

            props.onChange({ target: { name: props.name, value: newValue } });

            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus({ preventScroll: true });
                    inputRef.current.setSelectionRange(newValue.length, newValue.length);
                }
            }, 0);

            return next;
        });
    };

    const onChangePhone = (event) => {
        let value = event.target.value.trim();
        if (addPrefix && !value.startsWith('+1')) {
            value = `+1 ${value.replace(/^\+1/, '')}`;
        }

        props.onChange({ ...event, target: { ...event.target, value } });
        setPhoneValidated(false);
        setPhoneErrorMessage('');
    };

    const isUniquePhone = (value) => {
        if (!value) return true;
        return !otherPhones?.some(({ phone, extension }) => {
            const samePhone = phone === value;
            const sameExt = (!ext && !extension) || ext === extension;
            return samePhone && sameExt;
        });
    };

    const validate = (event) => {
        const value = event.target.value?.trim();
        if (!value) return;

        const regExp = /^[+\-0-9(). ]+$/gi;
        if (!regExp.test(value)) {
            setPhoneErrorMessage('Invalid phone number format');
            setPhoneValidated(false);
            return;
        }

        if (!isUniquePhone(value)) {
            setPhoneErrorMessage('Phones must differ');
            setPhoneValidated(false);
            return;
        }

        setLoadingPhoneValidation(true);

        PhoneService.validate(session, value)
            .then((response) => {
                const { status, message, phone } = response.data;
                if (status === 'success') {
                    setPhoneErrorMessage('');
                    setPhoneValidated(true);
                    props.onChange({ target: { name: 'country_prefix_phone_number', value: phone.country_prefix, type: 'text' }});
                    // If US prefix is added, use the local format (e.g., (123) 456-7890).
                    // Otherwise, keep the full international number as entered (e.g., +44123456789).
                    if (addPrefix) {
                        props.onChange({ target: { name: props.name, value: phone.local_format, type: 'text' }});
                    } else {
                        props.onChange({ target: { name: props.name, value, type: 'text' }});
                    }

                } else {
                    setPhoneErrorMessage(message);
                    setPhoneValidated(false);
                    props.onChange({ target: { name: 'country_prefix_phone_number', value: '', type: 'text' }});
                    if (dataSet === "FO") {
                        props.onChange({ target: { name: props.name, value, type: 'text' }});
                    } else {
                        props.onChange({ target: { name: props.name, value: '', type: 'text' }});
                    }
                }
            })
            .catch((error) => {
                setPhoneErrorMessage('Validation error: ' + error.message);
                setPhoneValidated(false);
                if (dataSet === 'FO') {
                    props.onChange({ target: { name: props.name, value, type: 'text' }});
                } else {
                    props.onChange({ target: { name: props.name, value: '', type: 'text' }});
                }
                props.onChange({  target: { name: 'country_prefix_phone_number', value: '', type: 'text' }});
            })
            .finally(() => {
                setLoadingPhoneValidation(false);
            });

        if (afterOnBlur) afterOnBlur(event);
    };

    return (
        <FormControl fullWidth>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>US (+1)</span>
                    <input
                        type="checkbox"
                        checked={addPrefix}
                        onMouseDown={(e) => e.preventDefault()}
                        onChange={handlePhonePrefixChange}
                        disabled={props.disabled}
                    />
                </div>
                <TextField
                    {...props}
                    onChange={onChangePhone}
                    onBlur={validate}
                    InputProps={{
                        endAdornment: loadingPhoneValidation ? (
                            <CircularProgress color="inherit" size={20} />
                        ) : null,
                    }}
                    error={!!phoneErrorMessage}
                />
            </div>
            <span
                style={{
                    color: phoneValidated ? 'green' : 'red',
                    fontSize: '14px',
                    fontWeight: 400,
                }}
            >
                {phoneValidated ? 'Validated correctly' : phoneErrorMessage}
            </span>
        </FormControl>
    );
};

export default PhoneTextField;
